module.exports = __webpack_public_path__ + "static/img/25d.62def5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/25d.jpg
// module id = DRPq
// module chunks = 0